import React, { Component } from 'react';
import './Page.css';
import SortableLists from './SortableLists/SortableLists';
import MainLayoutContainer from '../MainLayoutContainer/MainLayoutContainer';
import ElementSelector from './ElementSelector/ElementSelector';

//TODO: this starts to become a "god class" and needs refactoring
class Page extends Component {
    prepareData = (type) => {
        let data = require(`./../../assets/elements/${type}.js`);
        return (!data ? null :
            data.map((d) => {
                let newObject = Object.assign({}, d, { type: type });
                return newObject;
            }));
    };

    getSortableLists = () => {
        const Lists = <SortableLists
            {...this.props}
        />;
        return (Lists);
    };

    getElementsView = () => this.getSortableLists();

    getSidebarTemplateMenu = () => (
        <React.Fragment>
            <ElementSelector
                prepareData={this.prepareData}
                {...this.props}
            />
        </React.Fragment>
    )
    //LIFECYCLE METHODS
    //on mount, bind elements to sidebar
    componentDidMount = () => { 
        this.props.sidebarRef.current.changeSidebarTemplateMenu(this.getSidebarTemplateMenu);
    };

    render = () => (
        <React.Fragment>
            <MainLayoutContainer
                header={this.props.pageHeader}
                navbarContent={this.props.navbar}
                sidebarContent={this.props.sidebar}
                elements={this.getElementsView()}
            />
        </React.Fragment>
    )
}
export default Page;


// WEBPACK FOOTER //
// ./src/containers/Page/Page.js